import {
  CHEMKIT_DASHBOARD_ENABLED_ENV,
  WINDOW_KEY_DASHBOARD_CONFIG,
  parseBooleanFlag,
} from './config';

export function ensureDashboardConfig(windowRef) {
  const existingDashboardConfig = windowRef[WINDOW_KEY_DASHBOARD_CONFIG] || {};
  windowRef[WINDOW_KEY_DASHBOARD_CONFIG] = {
    ...existingDashboardConfig,
    enabled: Object.prototype.hasOwnProperty.call(existingDashboardConfig, 'enabled')
      ? parseBooleanFlag(existingDashboardConfig.enabled, false)
      : parseBooleanFlag(CHEMKIT_DASHBOARD_ENABLED_ENV, false),
  };
}
